import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import api from '../../services/api';
import { getImageUrl } from '../../utils/imageUrl';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      const response = await api.get('/settings');
      const logoPath = response.data.data?.frontendMedia?.logoFull;
      if (logoPath) {
        setLogo(getImageUrl(logoPath));
      }
    } catch (error) {
      console.error('Error fetching logo:', error);
    }
  };

  const menuItems = [
    { title: 'الرئيسية', href: '/' },
    { title: 'خدماتنا', href: '/services' },
    { title: 'مشاريعنا', href: '/projects' },
    { title: 'من نحن', href: '/about' },
    { title: 'شركاء النجاح', href: '/partners' },
    { title: 'المدونة', href: '/blog' },
    { title: 'تواصل معنا', href: '/contact' }
  ];

  return (
    <motion.nav
      className={`navigation ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="nav-container">
        {/* Language Selector - Left Side */}
        <div className="language-selector">
          <select className="language-dropdown" aria-label="Language selector">
            <option value="ar">العربية</option>
            <option value="en">English</option>
          </select>
        </div>

        {/* Navigation Menu - Center */}
        <ul className="nav-menu desktop-menu">
          {menuItems.map((item, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 + 0.3 }}
            >
              <Link to={item.href}>{item.title}</Link>
            </motion.li>
          ))}
        </ul>

        {/* Logo - Right Side */}
        <div className="nav-logo">
          <Link to="/">
            {logo ? (
              <img src={logo} alt="زاد الماسية" className="logo-image" />
            ) : (
              <h2>زاد الماسية</h2>
            )}
          </Link>
        </div>

        <button
          className={`mobile-toggle ${mobileOpen ? 'active' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileOpen ? 'active' : ''}`}>
        <ul>
          {menuItems.map((item, index) => (
            <li key={index}>
              <Link to={item.href} onClick={() => setMobileOpen(false)}>
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
        <div className="mobile-language-selector">
          <select className="language-dropdown" aria-label="Language selector">
            <option value="ar">العربية</option>
            <option value="en">English</option>
          </select>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
